import { h, Component } from 'preact';

class AutoSuggest extends Component{
  constructor(props){
      super(props);
      // this.state={data:this.props.data};
      this.title=this.props.title;
  }

 doSearch (event){
  		let url = event.target.getAttribute('data-href');
  		let keyword = event.target.innerHTML;
      if(typeof dataLayer !== 'undefined' && dataLayer) {
        dataLayer.push({"event":"pwa_cnb_event_snb_textSearchCompleted"})
      }
  		window.location.href = url;
  }
  returnSearchList(data) {
     let htmlElement = [];
     const searchList = data;
      searchList.map(item => {
        if(item.url){
          htmlElement.push(
             <li class="mdc-list-item" data-href={item.url} onClick={this.doSearch} >{item.keyworddata}</li>
          );
        }
      });
      return htmlElement;
  }

  render(props,state){
    return (<div>
               <h5>{this.title}</h5>
           			<ul class="mdc-list">
           				{this.returnSearchList(this.props.data)}
           			</ul>
           	</div>);
  }
}
export default AutoSuggest;



// WEBPACK FOOTER //
// ../q-cars/src/components/common/AutoSuggest.js